export const mapStylesSettings: google.maps.MapTypeStyle[] = [
  /*
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#ebe3cd',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#523735',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f1e6',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'administrative',
    stylers: [
      {
        color: '#c9b2a6',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        color: '#dcd2be',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        color: '#ae9e90',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'landscape.natural',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'poi',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'poi',
    stylers: [
      {
        color: '#93817c',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'geometry.fill',
    featureType: 'poi.park',
    stylers: [
      {
        color: '#a5b076',
      },
    ],
  },
  {
    elementType: 'labels.text',
    featureType: 'poi.park',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'poi.park',
    stylers: [
      {
        color: '#447530',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'road',
    stylers: [
      {
        color: '#f5f1e6',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'road.arterial',
    stylers: [
      {
        color: '#fdfcf8',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'road.highway',
    stylers: [
      {
        color: '#f8c967',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'road.highway',
    stylers: [
      {
        color: '#e9bc62',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'road.highway.controlled_access',
    stylers: [
      {
        color: '#e98d58',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    featureType: 'road.highway.controlled_access',
    stylers: [
      {
        color: '#db8555',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'road.local',
    stylers: [
      {
        color: '#806b63',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'transit.line',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'transit.line',
    stylers: [
      {
        color: '#8f7d77',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    featureType: 'transit.line',
    stylers: [
      {
        color: '#ebe3cd',
      },
    ],
  },
  {
    elementType: 'geometry',
    featureType: 'transit.station',
    stylers: [
      {
        color: '#dfd2ae',
      },
    ],
  },
  {
    elementType: 'geometry.fill',
    featureType: 'water',
    stylers: [
      {
        color: '#b9d3c2',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    featureType: 'water',
    stylers: [
      {
        color: '#92998d',
      },
    ],
  },

   */
];
